import { Typography } from '@mui/material';
import type { Theme } from '@mui/system';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';

const footNoteStyle = {
  base: {
    fontWeight: 500,
    color: (theme: Theme) => theme.palette.text.secondary,
  },
};

const FootNote = ({ sx, ...props }: ComponentProps<typeof Typography>) => {
  return (
    <Typography
      sx={combineSx(footNoteStyle.base, sx)}
      fontSize='fontSizes.smallest'
      data-id='foot-note'
      {...props}
    />
  );
};

export { FootNote };
